function callOnce(fun) {
    let result = null;
    return () => {
        if (!result) {
            result = { value: fun() };
        }
        return result.value;
    };
}
const isMobile = callOnce(() => {
    if (/Mobi/i.test(navigator.userAgent) ||
        /Android/i.test(navigator.userAgent)) {
        return true;
    }
    if (/iPad|iPhone|iPod/.test(navigator.platform)) {
        return true;
    }
    if (/Macintosh/i.test(navigator.userAgent) &&
        navigator.maxTouchPoints &&
        navigator.maxTouchPoints > 1) {
        // iPad pro
        return true;
    }
    return false;
});
const isElectron = callOnce(() => {
    // Renderer process
    if (typeof window !== "undefined" &&
        typeof window.process === "object" &&
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        window.process.type === "renderer") {
        return true;
    }
    // Main process
    if (typeof process !== "undefined" &&
        typeof process.versions === "object" &&
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        !!process.versions.electron) {
        return true;
    }
    // Detect the user agent when the `nodeIntegration` option is set to true
    if (typeof navigator === "object" &&
        typeof navigator.userAgent === "string" &&
        navigator.userAgent.indexOf("Electron") >= 0) {
        return true;
    }
    return false;
});
/**
 * Try to launch the desktop version using the custom protocol `decentraland://position=x,y&realm=zzz`
 * and return a boolean that represents if a loss of focus was detected on the current window
 * (assuming it was due to the interaction generated by the desktop version)
 */
const launchDesktopApp = async (options) => {
    // prevent launch for desktop and mobile
    if (isElectron() || isMobile()) {
        return false;
    }
    const customProtocolParams = [];
    if (options.position) {
        customProtocolParams.push(`position=${options.position}`);
    }
    if (options.realm) {
        customProtocolParams.push(`realm=${options.realm}`);
    }
    const customProtocolTarget = `decentraland://?${customProtocolParams.join("&")}`;
    // assume that the desktop version is installed only if
    // we detect a loss of focus on window
    let installed = false;
    const isInstalled = () => {
        installed = true;
    };
    window.addEventListener("blur", isInstalled);
    // inject an iframe that open the desktop version
    // NOTE: this can be also achieved with
    // ```js
    //   window.location.href = customProtocolTarget
    // ```
    // but in safari redirects into an invalid url if the desktop
    // client is not installed
    const iframe = document.createElement("iframe");
    iframe.setAttribute("style", "display: none");
    iframe.src = customProtocolTarget;
    document.body.appendChild(iframe);
    // wait half of a second to detect the loss of focus because
    // the time it takes for the `blur` event to be fired varies
    // depending on the browser
    return new Promise((resolve) => {
        setTimeout(() => {
            window.removeEventListener("blur", isInstalled);
            document.body.removeChild(iframe);
            console.log("installed", installed);
            resolve(installed);
        }, 500);
    });
};
export { launchDesktopApp };
//# sourceMappingURL=jumpIn.js.map